<div class="col has-validation" [class.my-2]="!dense()">
  <div [style.display]="'flex'">
    @if (inputFormControl()) {
      <input
        class="form-check-input"
        type="checkbox"
        [id]="controlId"
        [checked]="isChecked()"
        [disabled]="disabled()"
        (change)="onToggle($any($event.target).checked)"
        [formControl]="inputFormControl()!"
      />
    } @else {
      <input
        class="form-check-input"
        type="checkbox"
        [id]="controlId"
        [checked]="isChecked()"
        [disabled]="disabled()"
        (change)="onToggle($any($event.target).checked)"
      />
    }
    <label
      class="form-check-label label"
      [class.required]="hasRequiredValidator()"
      [for]="controlId"
    >
      {{ label() | translate }}
    </label>
  </div>

  @if (
    inputFormControl() &&
    inputFormControl()!.touched &&
    inputFormControl()!.invalid
  ) {
    <div class="feedback">
      @if (errorKeys().length > 0) {
        {{ getErrorMessage(errorKeys()[0]) | translate }}
      }
    </div>
  } @else if (leaveSpaceForValidation()) {
    @if (!dense()) {
      <div class="placeholder-feedback"></div>
    }
  }
</div>
